










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'NavButton',
})
export default class extends Vue {
  @Prop({ required: true }) private icon!: string;

  @Prop({ required: true }) private title!: string;

  @Prop({ default: () => '' }) private subTitle!: string;

  get subTitleStyle() {
    return this.subTitle === '' ? 'color:#fff' : '';
  }

  get subTitleValue() {
    return this.subTitle === '' ? '-' : this.subTitle;
  }

  get iconUrl() {
    return require(`@/assets/${this.icon}`);
  }

  private enter() {
    this.$emit('enter');
  }
}
